module.exports = __webpack_public_path__ + "img/Pattern01.075ec26e.png";